import React, { Component } from 'react';
import { connect } from "react-redux";
import WetSlider from './WetSlider.js';
import {updateParameter} from 'operations/actions.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import Dropdown from 'react-dropdown';

class DelayEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            delayEffect: props.delayEffect,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.delayEffect = nextProps.delayEffect;
        return true;
    }

    handleOptionChange(evt) {
        this.setState(this.state);
    }

    handleFeedbackChange(feedback) {
        this.state.delayEffect.setFeedback(feedback);
        this.setState(this.state);
    }

    handleDelayTimeChange(delayTime) {
        this.props.sequencerEngine.operationManager.dispatch(
            updateParameter(
                this.state.delayEffect.rateParameter, delayTime.value));
        this.setState(this.state);
    }

    handleWetChange(wet) {
        this.state.delayEffect.setWet(wet);
        this.setState(this.state);
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.delayEffect.isEnabled();
    }

    get delay() {
        return this.state.delayEffect;
    }

    onChangeSynced(synced) {
        document.activeElement.blur();
        this.delay.isSynced = synced === 'unsynced';
        this.setState(this.state);
    }

    render() {
        let delay = this.state.delayEffect;
        let feedback = delay.getFeedback();
        let delayTime = delay.rawDelayRate;
        let isSynced = delay.isSynced;
        var wet = delay.getWet();
        let className = this.props.automation !== undefined ?
            'enabled effect effect-automation' :
            delay.isEnabled() ? 'effect enabled' :
            'effect disabled';
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                  <div className="refined-checkbox-preferences lfo-synced-checkbox">
                    <label>
                      <input 
                        type="checkbox"
                        value={isSynced ? "synced" : "unsynced"}
                        checked={isSynced}
                        onChange={(e) => this.onChangeSynced(e.target.value)} />
                        Synced
                      </label>
                    </div>
                      {isSynced ?
                       <div className="lfo-rate-dropdown">
              <div className="lfo-rate-label">
                Rate:
              </div>
                <Dropdown
                  className='osc-type-dropdown'
                  controlClassName='osc-type-control-dropdown'
                  arrowClassName='osc-type-arrow-dropdown'
                  options={delayTimeOptions}
                  onChange={(o) => this.handleDelayTimeChange(o)}
                  value={getDelayTimeOption(this.delay.rawDelayRate)}
                  placeholder="Rate" />
                 <div className="clear-fix"/>
                           </div>
                           :
        
                    <EffectParameterSlider
                       effectNumber={this.props.effectNumber}
                       name={'Rate'}
                       parameter={this.state.delayEffect.rateParameter}
                       onParameterChanged={this.props.onParameterChanged}
                       sequencerEngine={this.props.sequencerEngine}
                       isParameter={true}
                       lfoEnabled={true}
                       step={1}
                       min={1}
                       max={1000}
                          />}
               
                   <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                         automation={this.props.automation}
                         name='Feedback'
                         lfoEnabled={true}
                         selectedParameter={this.props.selectedParameter}
                         sequencerEngine={this.props.sequencerEngine}
                         unit='%'
                         parameter={this.state.delayEffect.feedbackParameter}
                         onParameterChanged={this.props.onParameterChanged}
                         isParameter={true}
                         displayFunction={(feedback) => Math.floor(feedback*100)}
                         step={0.01}
                         max={1}
                         min={0}
                        />
                    <WetSlider
                          effectNumber={this.props.effectNumber}
                          sequencerEngine={this.props.sequencerEngine}
                          automation={this.props.automation}
                          selectedParameter={this.props.selectedParameter}
                          onParameterChanged={this.props.onParameterChanged}
                          effect={this.state.delayEffect}/>
                </div>} 
            </div>
        );
    }
}

const delayTimeOptions = [
    {value: '1n', label:'1'},
    {value: '2n', label:'1/2'},
    {value: '4n', label:'1/4'},
    {value: '4t', label:'1/4t'},
    {value: '8n', label:'1/8'},
    {value: '8n.', label:'1/8.'},
    {value: '8t', label:'1/8t'},
    {value: '16n', label:'1/16'},
    {value: '16t', label:'1/16t'},
    {value: '32n', label:'1/32'}
];

function getDelayTimeOption(value) {
    var options = delayTimeOptions.filter((opt) => opt.value === value);
    if (options.length == 0) {
        return "16n";
    }
    return options[0];
}

const mapStateToProps = (state, props) => {
    return {
        rate: props.delayEffect.rateParameter.get(),
        isEnabled: props.delayEffect.isEnabled(),
    };
};

export default connect(mapStateToProps, null)(DelayEffect);

